import React, { FC } from "react";
import { Dashboard as DashboardIcon } from "@mui/icons-material";
import { PageTitle } from "../../components";

export const Admin: FC = () => (
  <PageTitle icon={<DashboardIcon />} title="Admin" testID="admin" />
);
